import * as classNames from "classnames";
import * as React from "react";

import { IMPDSelectProps, MPDSelect } from "src/mpd-library";

import "./styles.css";

export const Select: React.SFC<IMPDSelectProps> = props => {
  const { className, ...newProps } = props;
  const classes = classNames(className);

  return (
    <div className={classes}>
      <MPDSelect {...newProps} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/select/select.tsx